import React from 'react';

import { Button } from 'shared/presentation/components/molecules';
import { useLocale } from 'shared/presentation/contexts';

import * as S from './styles';

interface INotConfirmedProps {
  onContinue(): void;
}

const NotConfirmed: React.FC<INotConfirmedProps> = ({ onContinue }) => {
  const { t } = useLocale('checkin');

  return (
    <S.Container>
      <h1>{t('termsReminder.content.notConfirmed.title')}</h1>

      <p>{t('termsReminder.content.notConfirmed.text')}</p>

      <Button variant="primary" onClick={onContinue}>
        <span>{t('termsReminder.actions.continue')}</span>
      </Button>
    </S.Container>
  );
};

export default NotConfirmed;
